define('views/shared/list/icon_list',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/list/icon_list.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'merchantLogos',
        tagName  : 'ul',
        isRender : true,
        template : _.template(Template),
        events   : {},
        initialize: function(options){
            options = options || {};

            this.icons = options.icons;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            this.addIcons();

            return this;
        },

        addIcons: function(){
            var list = this.$el;

            if(_.isArray(this.icons)){

                this.icons.forEach(function(icon, index){
                
                    var icon_item = '<li class="merchantLogo ' + icon.property + '">' + pf.getContent(icon) + '</li>';
                    
                    list.append(icon_item);

                });

            }

        },

        close: function(){}
    });
});

